<template>
    <ScrollableVueCard :title="$t('lang.busqueda.SEARCH ADDRESS JSON')" >
    <div style="margin: 10px; margin-top: 20px">
        <blockquote>
            <v-textarea
              id="holder"
              rows="9"
              :hide-details="true"
              v-model="jsonstr"
              name="input-7-4"
              outlined
              ref="jsonText"
              @keydown.enter.exact.prevent
              @keyup.enter.exact="buscar"
              @keydown.enter.shift.exact="newline"
              @drop="eventDrop($event)"
              @dragover="allowDrop($event)"
              @dragleave="cancelDrop($event)"
              :label="$t('lang.busqueda.JSON FILE')"
            ></v-textarea>
        </blockquote>
        <BR/>
        <!--<v-select
            :items="zoomlevels"
            v-model="zoomSelected"
            name="zoomSelected"
            item-text="name"
            v-bind:label="$t('lang.busqueda.ZOOM LEVEL')"
            dense
            outlined
          >
          <template slot='selection' slot-scope='{ item }'>
            {{ $t('lang.busqueda.' + item.name) }}
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ $t('lang.busqueda.' + item.name) }}
          </template>
          </v-select>-->
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn
            block
            elevation="2"
            text
            @click="buscar()"
            >Buscar</v-btn>
        </v-card-actions>

    </div>
    <v-snackbar v-if="snackbarsuccess" v-model="snackbarsuccess" :bottom= false color="error" :left= false :multi-line= false :right= false :timeout="timeout" :top= true :vertical= true>
        {{ successtext }}
    </v-snackbar>
    </ScrollableVueCard>
    
</template>


<script>
import ScrollableVueCard from '@/components/ScrollableVueCard/ScrollableVueCard.vue'
import Alarma from '@/components/ListaAlarmas/Alarma/Alarma.vue'
import {AlertType, zoomlevels} from '@/views/helpers'
import store from '@/store'

export default {
    name: 'ComponenteAlarmas',
    props:{
        title: String,
        pendientes: Boolean
    },
    components:{
        Alarma,
        ScrollableVueCard
    },
    mounted(){
        this.jsonstr = this.$i18n.t('lang.busqueda.JSON DEFAULT')
    },
    data: () => ({
        AlertType,
        zoomlevels,
        zoomSelected: zoomlevels[1].value,
        jsonstr: '',
        snackbarsuccess: false,
        successtext: '',
        timeout: 2500,
        bindlabel: "",
        jsonerror: '',
        textbeforecanceled: ''
    }),
    computed: {
        prettyFormat: function() {
            // reset error
            this.jsonerror = ""
            let jsonValue = ""
            try {
                // try to parse
                //console.log("prettyFormat", JSON.parse(this.jsonstr))
                jsonValue = JSON.parse(this.jsonstr)
                var places = jsonValue.places
                //console.log("prettyFormat", places == undefined)

                if(places == null || places == undefined){
                    throw { 'message' : 'Es necesario agregar un json válido'}
                }
                else{
                    this.total = jsonValue.places.length
                    this.current = 1
                    this.center = []

                    places.map(element => {
                        if (element == " " || element == "" || !element) {
                            throw { 'message' : 'El elemento ' + this.current + ' no es una dirección válida' }
                        }
                        this.current = this.current + 1;
                    })
                }
            }
            catch(e) {
                //console.log(e)
                this.jsonerror = JSON.stringify(e.message)
            }
            return JSON.stringify(jsonValue, null, 2)
        }
    },
    methods:{
        eventDrop(e){
            //this.className = '';
            e.preventDefault();

            var file = e.dataTransfer.files[0],
                reader = new FileReader();
            reader.onload = 
                (function(context){
                    var address = context.jsonstr;
                    return function(e){
                        context.jsonstr = e.target.result;
                    };
                })(this); 
                            

            this.bindlabel = ""
            //this.address = e.target.result;
            //console.log(file);
            reader.readAsText(file);

            return false;
        },
        allowDrop(event) {
            event.preventDefault();

            if(this.jsonstr != ""){
                this.textbeforecanceled = this.jsonstr
            }

            this.jsonstr = ""
        },
        cancelDrop(event) {
            this.jsonstr = this.textbeforecanceled
        },
        buscar(){
            var pretty = this.prettyFormat;

            console.log("buscar", this.zoomSelected)
            console.log("buscar", this.jsonerror)
            console.log("buscar", this.jsonstr)

            if(!this.zoomSelected){
                this.snackbarsuccess = true
                this.successtext = "Nivel de zoom no establecido"
            }
            else if (this.jsonerror){
                this.snackbarsuccess = true
                this.successtext = this.jsonerror
            }
            else if (!this.jsonstr){
                this.snackbarsuccess = true
                this.successtext = "Es necesario agregar una dirección válida"
            }
            else{
                this.$emit('search-query-json', {zoom: this.zoomSelected, query: this.jsonstr});
            }
        },
        newline(){
            
        }
    }
}
</script>

<style scoped> 
::v-deep textarea {
  resize: none !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
  border-color: red !important;;
}


</style>